__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['warm-welcome-video'].baseUrl;
import WarmWelcomeVideo from './components/WarmWelcomeVideo';
export default WarmWelcomeVideo;
;
if (!global.BROWSER) {
  WarmWelcomeVideo.appConfig = Object.assign({}, WarmWelcomeVideo.appConfig, {
    appCompatibility: "5.x"
  });
}
;
if (!global.BROWSER) {
  WarmWelcomeVideo.appConfig = Object.assign({}, WarmWelcomeVideo.appConfig, {
    requiredExternals: {
      '@americanexpress/browser-performance-mark': '^3.0.0',
      '@americanexpress/product-ducks': '^1.3.3',
      '@americanexpress/react-ddl': '^0.1.8',
      '@americanexpress/reactlytics': '^1.2.8',
      'react-intl': '^3.12.1'
    }
  });
}